/* Ficha de producto Topciment (plantilla product.tc): galería, cantidad, pestañas y calculadora. */
(() => {
  const root = document.querySelector("[data-tc-pdp]");
  if (!root) return;

  // ---------- Galería ----------
  const main = root.querySelector("[data-tc-main]");
  root.querySelectorAll(".tc-gallery__thumbs button").forEach((btn) => {
    btn.addEventListener("click", () => {
      if (!main) return;
      main.removeAttribute("srcset");
      main.src = btn.dataset.src;
      root.querySelectorAll(".tc-gallery__thumbs button").forEach((b) => b.classList.toggle("is-active", b === btn));
    });
  });

  // ---------- Cantidad ----------
  const qtyInput = root.querySelector("[data-tc-qty-input]");
  root.querySelectorAll("[data-tc-qty]").forEach((btn) => {
    btn.addEventListener("click", () => {
      const v = Math.max(1, (parseInt(qtyInput.value, 10) || 1) + Number(btn.dataset.tcQty));
      qtyInput.value = v;
    });
  });

  // ---------- Especificaciones: listas "Etiqueta: valor" -> tabla ----------
  root.querySelectorAll("[data-tc-spec] ul, [data-tc-spec] ol").forEach((list) => {
    const items = [...list.children].filter((li) => li.tagName === "LI");
    const kv = items.map((li) => {
      const text = li.textContent.replace(/\s+/g, " ").trim();
      const m = text.match(/^([^:]{2,60}):\s*(.+)$/);
      return m ? { li, k: m[1].trim(), v: m[2].trim().replace(/\.$/, "") } : { li };
    });
    const pairs = kv.filter((x) => x.k);
    if (pairs.length < 2 || pairs.length < items.length * 0.6) return;
    const table = document.createElement("table");
    table.className = "tc-spec__table";
    pairs.forEach(({ k, v }) => {
      const tr = table.insertRow();
      const th = document.createElement("th");
      th.textContent = k;
      const td = document.createElement("td");
      td.textContent = v;
      tr.append(th, td);
    });
    list.before(table);
    const rest = kv.filter((x) => !x.k && x.li.textContent.trim());
    if (rest.length) {
      const ul = document.createElement("ul");
      rest.forEach((x) => ul.appendChild(x.li));
      list.replaceWith(ul);
    } else list.remove();
  });

  // ---------- Modo de empleo: tiempo entre capas (de las especificaciones) ----------
  const dry = root.querySelector("[data-tc-drying]");
  if (dry) {
    const re = /(secado entre capas|entre capas|between coats|entre couches|zwischen den schichten|tra le mani|entre camadas|tussen de lagen|mellem lagene|mellom lagene|mellan skikten|kerrosten välillä|mezi vrstvami|entre capes)[^:]*:\s*(.+)/i;
    const cells = [...root.querySelectorAll("[data-tc-spec] li, [data-tc-spec] tr, [data-tc-spec] p")];
    for (const c of cells) {
      const m = c.textContent.replace(/\s+/g, " ").trim().match(re) || (c.tagName === "TR" && /(entre capas|between coats|entre couches|zwischen|tra le mani|entre camadas|tussen|mellem|mellom|mellan|välillä|mezi|entre capes)/i.test(c.cells[0]?.textContent || "") ? [0, 0, c.cells[1].textContent] : null);
      if (m && m[2]) { dry.querySelector("strong").textContent = String(m[2]).trim().replace(/\.$/, ""); dry.hidden = false; break; }
    }
  }
  // ---------- Ventajas y pasos: quitar los ":" que quedan tras la negrita (leading colon) ----------
  root.querySelectorAll(".tc-desc__feat li > strong:first-child, .tc-use__steps li > strong:first-child").forEach((b) => {
    b.textContent = b.textContent.replace(/s*:s*$/, "");
    const n = b.nextSibling;
    if (n && n.nodeType === 3) n.textContent = n.textContent.replace(/^s*:s*/, "");
  });

  // ---------- Modo de empleo: avisos destacados ----------
  root.querySelectorAll("[data-tc-use] li, [data-tc-use] p").forEach((el) => {
    if (/^(importante|important|wichtig|achtung|attention|attenzione|nota|note|no aplicar|evitar|precauci[oó]n)\b/i.test(el.textContent.trim())) el.classList.add("tc-warn");
  });
  // ---------- Ir a la calculadora ----------
  root.querySelectorAll("[data-tc-goto-calc]").forEach((a) => a.addEventListener("click", (e) => {
    const c = root.querySelector("#tc-calc");
    if (!c) return;
    e.preventDefault();
    c.scrollIntoView({ behavior: "smooth", block: "start" });
    const area = c.querySelector("[data-tc-area]");
    if (area) setTimeout(() => area.focus({ preventScroll: true }), 500);
  }));

  // ---------- Pestañas ----------
  const tabs = root.querySelector("[data-tc-tabs]");
  if (tabs) {
    const buttons = tabs.querySelectorAll("[role=tab]");
    const panels = tabs.querySelectorAll("[role=tabpanel]");
    const select = (i) => {
      buttons.forEach((b) => b.setAttribute("aria-selected", String(b.dataset.tab === String(i))));
      panels.forEach((p) => (p.hidden = p.dataset.panel !== String(i)));
    };
    buttons.forEach((b) => b.addEventListener("click", () => select(b.dataset.tab)));
    // open a tab from the URL (#tc-tab-3) so it can be linked directly
    const hm = location.hash.match(/^#tc-tab-(d+)$/) || [null, new URLSearchParams(location.search).get("tab")];
    if (hm[1] && tabs.querySelector(`[data-tab="${hm[1]}"]`)) {
      select(hm[1]);
      window.addEventListener("load", () => tabs.scrollIntoView({ block: "start" }));
    }
    tabs.querySelector("[role=tablist]").addEventListener("keydown", (e) => {
      if (e.key !== "ArrowRight" && e.key !== "ArrowLeft") return;
      const list = [...buttons];
      const cur = list.findIndex((b) => b.getAttribute("aria-selected") === "true");
      const next = list[(cur + (e.key === "ArrowRight" ? 1 : -1) + list.length) % list.length];
      next.focus();
      select(next.dataset.tab);
    });
  }


  // Kit A+B lines share a hidden `_kit` property: tc-kit-cart.js keeps their quantities together in the cart.
  const kitItems = (a, b, quantity) => {
    const properties = { _kit: [Number(a), Number(b)].sort((x, y) => x - y).join("-") };
    return [{ id: Number(a), quantity, properties }, { id: Number(b), quantity, properties }];
  };

  // Adds items to the cart and refreshes the theme's cart drawer (falls back to /cart).
  async function addToCart(items) {
    const drawer = document.querySelector("cart-drawer") || document.querySelector("cart-notification");
    const body = { items };
    if (drawer && drawer.getSectionsToRender) {
      body.sections = drawer.getSectionsToRender().map((s) => s.id);
      body.sections_url = window.location.pathname;
    }
    const res = await fetch(`${(window.routes && routes.cart_add_url) || "/cart/add"}.js`, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify(body),
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.description || data.message);
    if (!drawer || !data.sections) return (window.location.href = (window.routes && routes.cart_url) || "/cart");
    drawer.getSectionsToRender().forEach((s) => {
      const el = document.getElementById(s.id);
      const html = new DOMParser().parseFromString(data.sections[s.id], "text/html");
      const inner = html.querySelector("#form-mini-cart");
      if (el && inner) el.innerHTML = inner.innerHTML;
    });
    const cart = await (await fetch("/cart.json")).json();
    document.querySelectorAll(".cart-count").forEach((el) => {
      el.innerHTML = el.classList.contains("cart-count-drawer") ? `(${cart.item_count})` : cart.item_count;
    });
    drawer.classList.remove("is-empty");
    if (drawer.cartAction) drawer.cartAction();
    // same refresh hooks the theme runs after its own add-to-cart (lazy images, sliders, terms checkbox)
    try { window.BlsLazyloadImg && BlsLazyloadImg.init(); } catch (e) {}
    try { window.BlsSettingsSwiper && BlsSettingsSwiper.init(); } catch (e) {}
    try { window.Shopify && Shopify.termsConditionsAction && Shopify.termsConditionsAction(); } catch (e) {}
    if (drawer.open) drawer.open();
  }

  // ---------- Completa tu sistema: añadir rápido ----------
  root.querySelectorAll("[data-tc-quick-add]").forEach((btn) => {
    btn.addEventListener("click", async () => {
      btn.disabled = true;
      btn.classList.add("btn-loading");
      try {
        await addToCart([{ id: Number(btn.dataset.tcQuickAdd), quantity: 1 }]);
        btn.classList.add("is-added");
      } catch (e) {
        alert(e.message || "Error");
      } finally {
        btn.disabled = false;
        btn.classList.remove("btn-loading");
      }
    });
  });

  // ---------- Kit A+B: solo se venden juntos ----------
  // The buy button adds this product + the chosen partner in the same quantity.
  const kit = root.querySelector("[data-tc-kit]");
  const kitChoice = () => kit && kit.querySelector("input[type=radio]:checked");
  if (kit) {
    // same output as Liquid's | money (shop.money_format), e.g. "€{{amount_with_comma_separator}}"
    const kitMoney = { format: (v) => {
      const fmt = kit.dataset.moneyFormat || "{{amount}}";
      const name = (fmt.match(/\{\{\s*(\w+)\s*\}\}/) || [, "amount"])[1];
      const dec = /no_decimals/.test(name) ? 0 : 2;
      const [int, frac] = v.toFixed(dec).split(".");
      const comma = /comma_separator/.test(name);
      const ints = int.replace(/\B(?=(\d{3})+(?!\d))/g, comma ? "." : name.includes("apostrophe") ? "'" : ",");
      return fmt.replace(/\{\{\s*\w+\s*\}\}/, ints + (frac ? (comma ? "," : ".") + frac : ""));
    } };
    const refresh = () => {
      const c = kitChoice();
      kit.querySelectorAll(".tc-kit__opt").forEach((o) => o.classList.toggle("is-current", o.contains(c)));
      if (!c) return;
      const total = (Number(kit.dataset.ownPrice) + Number(c.dataset.price)) / 100;
      const t = root.querySelector("[data-tc-kit-total]");
      if (t) t.textContent = kitMoney.format(total);
      kit.querySelector("[data-tc-kit-name]").textContent = c.dataset.title;
      kit.querySelector("[data-tc-kit-price]").textContent = kitMoney.format(Number(c.dataset.price) / 100);
      // B page: the B's yield is the mix's, i.e. the chosen A's
      const y = c.closest(".tc-kit__opt").querySelector("[data-tc-yield]");
      root.querySelectorAll("[data-tc-yield-mirror]").forEach((el) => { if (y) el.textContent = y.textContent; });
      kit.dispatchEvent(new CustomEvent("tc:kit", { detail: { id: Number(c.value), price: Number(c.dataset.price), calc: c.dataset.calc } }));
    };
    kit.addEventListener("change", refresh);
    refresh();

    // capture on an ancestor: runs before the theme's <product-form> submit handler
    root.addEventListener("submit", async (e) => {
      const form = e.target.closest("product-form form");
      if (!form) return;
      e.preventDefault();
      e.stopPropagation();
      const c = kitChoice();
      const btn = form.querySelector("[type=submit]");
      if (!c || btn.disabled) return;
      btn.disabled = true;
      btn.classList.add("btn-loading");
      try {
        const qty = Math.max(1, parseInt(qtyInput.value, 10) || 1);
        await addToCart(kitItems(kit.dataset.ownId, c.value, qty));
      } catch (err) {
        alert(err.message || "Error");
      } finally {
        btn.disabled = false;
        btn.classList.remove("btn-loading");
      }
    }, true);
  }

  // ---------- Calculadora ----------
  const calc = root.querySelector("[data-tc-calc]");
  if (!calc) return;
  let consumo = parseFloat(calc.dataset.consumo);
  const unit = calc.dataset.unit || "kg";
  // packs: {id, size, price, available}; kit packs (A+B) also carry a/b (each content) and kit (B variant)
  const parseFormats = (json) => {
    try {
      return JSON.parse(json).filter((f) => f.size > 0 && f.available && !f.kitMissing);
    } catch (e) {
      return [];
    }
  };
  let formats = parseFormats(calc.dataset.formats);
  const money = new Intl.NumberFormat(calc.dataset.locale || "es", { style: "currency", currency: calc.dataset.currency || "EUR" });
  const num = new Intl.NumberFormat(calc.dataset.locale || "es", { maximumFractionDigits: 1 });
  const num2 = new Intl.NumberFormat(calc.dataset.locale || "es", { maximumFractionDigits: 2 });
  const esc = (t) => String(t).replace(/[&<>"]/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" })[c]);
  // "Componente A Industtrial BASE 18 Kg LQ" -> "Industtrial BASE" (size and transport codes go in their own column)
  const shortName = (t) => String(t || "").replace(/^\S+\s+[AB]\s+/, "").replace(/\s*\d+(?:[.,]\d+)?\s*kg\b/gi, "").replace(/\s+(?:LQ|ADR)\b/g, "").trim();
  const part = (tag, name, size) => `<span class="tc-calc__part"><b class="tc-ab tc-ab--${tag.toLowerCase()}">${tag}</b><span>${esc(shortName(name))}</span><em>${num2.format(size)} ${unit}</em></span>`;
  const packItem = (p) =>
    p.kit && p.b
      ? `<li class="tc-calc__kit"><strong>${p.qty} × ${esc(calc.dataset.kitWord || "kit")} ${num2.format(p.size)} ${unit}</strong>${part("A", p.an, p.a)}${part("B", p.bn, p.b)}</li>`
      : `<li>${p.qty} × ${num2.format(p.size)} ${unit}</li>`;
  const area = calc.querySelector("[data-tc-area]");
  const coats = calc.querySelector("[data-tc-coats]");
  const out = calc.querySelector("[data-tc-out]");
  const MARGIN = 1.1; // 10 % de margen
  let plan = [];

  // Cheapest combination of packs covering `need` (small search: up to 3 formats, bounded counts).
  // Each pack adds a small penalty (2 % of the biggest pack's price) so near-ties go to fewer packs
  // (e.g. 2 kits of 18 kg rather than 8 of 4,5 kg for 88 cents less).
  function bestPacks(need) {
    if (!formats.length) return [];
    const fs = [...formats].sort((a, b) => b.size - a.size).slice(0, 3);
    const penalty = 0.02 * Math.max(...fs.map((f) => f.price));
    let best = null;
    const maxOf = (f) => Math.ceil(need / f.size);
    const counts = new Array(fs.length).fill(0);
    const walk = (i, covered, cost) => {
      if (best && cost >= best.cost) return;
      if (covered >= need) {
        best = { cost, counts: [...counts] };
        return;
      }
      if (i >= fs.length) return;
      for (let n = maxOf(fs[i]); n >= 0; n--) {
        counts[i] = n;
        walk(i + 1, covered + n * fs[i].size, cost + n * (fs[i].price + penalty));
      }
      counts[i] = 0;
    };
    walk(0, 0, 0);
    if (!best) return [];
    return fs.map((f, i) => ({ ...f, qty: best.counts[i] })).filter((f) => f.qty > 0);
  }

  function update() {
    const m2 = parseFloat(String(area.value).replace(",", "."));
    if (!m2 || m2 <= 0) {
      out.hidden = true;
      return;
    }
    const need = m2 * consumo * Number(coats.value) * MARGIN;
    calc.querySelector("[data-tc-total]").textContent = `${num.format(need)} ${unit}`;
    plan = bestPacks(need);
    const ul = calc.querySelector("[data-tc-packs]");
    ul.innerHTML = plan.map(packItem).join("") || "<li>—</li>";
    // what the recommendation covers: "40,18 kg de mezcla A + B · para 20 m² a 2 capas"
    const cover = calc.querySelector("[data-tc-cover]");
    if (cover) {
      const kg = plan.reduce((t, p) => t + p.qty * p.size, 0);
      const n = Number(coats.value);
      const tpl = plan.some((p) => p.kit) ? cover.dataset.kit : cover.dataset.plain;
      cover.textContent = tpl
        .replace("%T", `${num2.format(kg)} ${unit}`)
        .replace("%A", num.format(m2))
        .replace("%C", `${n} ${n === 1 ? cover.dataset.coatOne : cover.dataset.coatOther}`);
      cover.hidden = !plan.length;
    }
    ul.classList.toggle("tc-calc__packs--kit", plan.some((p) => p.kit));
    calc.querySelectorAll("[data-tc-kit-hint]").forEach((h) => (h.hidden = !plan.some((p) => p.kit)));
    const total = plan.reduce((s, p) => s + p.qty * p.price, 0);
    calc.querySelector("[data-tc-price]").textContent = total ? money.format(total / 100) : "—";
    calc.querySelector("[data-tc-calc-add]").disabled = !plan.length;
    out.hidden = false;
  }
  const togglePacks = () => {
    calc.querySelector("[data-tc-packs]").closest("div").hidden = !formats.length;
    calc.querySelector(".tc-calc__cta").hidden = !formats.length;
  };
  togglePacks();
  area.addEventListener("input", update);
  // kit: this product's own format follows the partner chosen in the buy box
  // on a B page the chosen A brings its own consumption, coats and packs
  if (kit) kit.addEventListener("tc:kit", (e) => {
    if (e.detail.calc) {
      let d;
      try { d = JSON.parse(e.detail.calc); } catch (err) { return; }
      consumo = Number(d.consumo);
      formats = parseFormats(JSON.stringify(d.formats));
      coats.value = String(d.capas);
      const note = calc.querySelector("[data-tc-calc-note]");
      if (note && note.dataset.value) {
        note.textContent = note.textContent.replace(note.dataset.value, d.txt);
        note.dataset.value = d.txt;
      }
      togglePacks();
      update();
      return;
    }
    const own = formats.find((f) => f.id === Number(kit.dataset.ownId));
    if (!own) return;
    own.kit = e.detail.id;
    own.price = Number(kit.dataset.ownPrice) + e.detail.price;
    update();
  });
  coats.addEventListener("change", update);
  update(); // calculadora abierta desde el inicio con el valor por defecto (20 m²)

  // Add the whole plan to the cart and refresh the theme's cart drawer.
  calc.querySelector("[data-tc-calc-add]").addEventListener("click", async (ev) => {
    const btn = ev.currentTarget;
    if (!plan.length) return;
    btn.disabled = true;
    btn.classList.add("btn-loading");
    try {
      await addToCart(plan.flatMap((p) => (p.kit ? kitItems(p.id, p.kit, p.qty) : [{ id: p.id, quantity: p.qty }])));
    } catch (e) {
      alert(e.message || "Error");
    } finally {
      btn.disabled = false;
      btn.classList.remove("btn-loading");
    }
  });
})();
